var FilterableBox = {
	initializeFilterableBox: function(tagName) {
		this.filterTagName = tagName;
		this.filterBtnDiv = this.el.querySelector('.filterBtns');
		if (this.filterBtnDiv != undefined) {
			this.setupFilterBtns();
		}
	},

	setupFilterBtns: function(opacityOnly) {
		const filterButtons = this.filterBtnDiv.querySelectorAll(this.filterTagName);
		filterButtons.forEach(btn => {
			if (this.options.memberFilter == btn.getAttribute('class')) {
				btn.classList.add('selected');
			} else {
				btn.classList.remove('selected');
			}

			if (!opacityOnly) {
				this.safeObserve(btn, 'click', this.onFilterBtnClick.bind(this));
				this.safeObserve(btn, 'mouseover', this.onFilterBtnOver.bind(this));
				this.safeObserve(btn, 'mouseout', this.onFilterBtnOut.bind(this));
			}
		});
	},

	onFilterBtnClick: function(ev) {
		ev.preventDefault();
		ev.stopPropagation();
		if (this.requestRunning || this.disablePaging)
			return;

		var btn = ev.target.closest(this.filterTagName);
		if (this.options.memberFilter == btn.getAttribute('class').replace(/\s*selected\s*/, ''))
			return;

		this.options.memberFilter = btn.getAttribute('class').replace(/\s*selected\s*/, '');
		this.setupFilterBtns(true);
		this.options.currentPage = 0;
		this.refresh();
	},

	onFilterBtnOver: function(ev) {
		var btn = ev.target.closest(this.filterTagName);
		if (!btn.hover) {
			btn.hover = true;
			btn.classList.add('selected');
		}
	},

	onFilterBtnOut: function(ev) {
		var btn = ev.target.closest(this.filterTagName);
		btn.hover = false;
		if (this.options.memberFilter == btn.getAttribute('class').replace(/\s*selected\s*/, ''))
			btn.classList.add('selected');
		else
			btn.classList.remove('selected');
	}
};
